/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const printRefresh = () => $('#generate_invoice').click(event => setTimeout('location.reload();', 1000));

$(document).ready(printRefresh);
$(document).on('turbolink:load', printRefresh);
